import Crk from '@/mixins/crk/crk';
import { Mixins, Component, Prop, PropSync, Emit, Watch } from 'vue-property-decorator';
import { DigitalSign } from '../types/digital-sign';
import type IBPasswordField from "@/components/TextField/IBPasswordField.vue";
import type IBInputField from "@/components/TextField/IBInputField.vue";
import { TranslateResult } from "vue-i18n";

@Component
export default class AuthDigitalPassword extends Mixins(
	Crk
) {

	$refs!: {
		password: IBPasswordField | IBInputField
	}

	@Prop(Object)
	readonly digitalSign?: DigitalSign

	@PropSync('passwordErrorMessage', String)
	passwordErrorMessageLocal?: string;

	@PropSync('passwordValue', String)
	passwordLocal!: string;

	digitalSignNotConnected: boolean = false;

	digitalSignNotFound: boolean = false;

	minLengthPassword: number = 8;

	passwordErrorMessageMinLength: string = '';

	async checkDigitalSign(): Promise<DigitalSign | null> {
		const digitalSignList = await this.callbackIsignerConnected(true);

		this.digitalSignNotConnected = this.isError || !this.isConnected;

		if (!this.digitalSignNotConnected) {
			const digitalSign: DigitalSign | undefined = digitalSignList
				.find(item => this.digitalSign?.flCrmId === item.flCrmId
					&& this.digitalSign?.ulCrmId === item.ulCrmId);

			this.digitalSignNotFound = !digitalSign;

			if (digitalSign) return digitalSign;
		}

		return null;
	}

	async onSubmit() {
		if (!this.passwordLocal || this.passwordLocal.length < this.minLengthPassword) {
			this.passwordErrorMessageMinLength = this.$t('minLength', [this.minLengthPassword]) as string;

			return;
		}

		const digitalSign: DigitalSign | undefined = await this.checkDigitalSign();

		if (!this.digitalSignNotFound && !this.digitalSignNotConnected) {
			this.blurPasswordField();
			this.emitSubmit(digitalSign!);
		}
	}

	getPasswordFieldElement(): HTMLInputElement | undefined {
		// @ts-ignore
		return ((this.$refs.password as IBPasswordField)?.$refs?.field || (this.$refs.password as IBInputField)?.$refs?.textField)?.$refs?.input;
	}

	focusPasswordField() {
		this.$nextTick(() =>
			this.getPasswordFieldElement()?.focus());
	}

	blurPasswordField() {
		this.$nextTick(() =>
			this.getPasswordFieldElement()?.blur());
	}

	clearPasswordErrorMessage() {
		this.passwordErrorMessageLocal = '';
	}

	@Watch('passwordLocal')
	onPasswordChanged() {
		this.passwordLocal || this.focusPasswordField();

		if (this.passwordLocal.length === 8) this.passwordErrorMessageMinLength = '';
	}

	@Emit('submit')
	emitSubmit(digitalSign: DigitalSign): DigitalSign {
		return digitalSign;
	}

}
